import { call, put, takeLatest } from 'redux-saga/effects';

import { fetchEncodedData } from '../../../utility/requests';

import glossaryActionCreators from './actionCreators';
import actionTypes from './actionTypes';

function* getGlossaryData() {
    try {
        const glossaryUrl = `${window.__BASE_REST_URL__}/glossary?sort=fullName`;

        const { data } = yield call(fetchEncodedData, glossaryUrl);

        yield put(glossaryActionCreators.glossaryResponse(true, null, data));
    } catch (errors) {
        yield put(glossaryActionCreators.glossaryResponse(false, errors, null));
    }
}

export default function* watchLeaders() {
    yield takeLatest(actionTypes.REQUEST_GLOSSARY, getGlossaryData);
}
